let rs_general_error_message = "Something went wrong<br>Please contact the site administrator";

(function($){
	$(document).ready(function(){


		//Show-Hide order items button on the "Refund Select Order" page
		$(".refund-select-order-page .show-items").on('click', function(e){
			e.preventDefault();
			let $items = $(this).closest('.order-block').find('.items-wrapper');

			$(this).toggleClass('active');
			$items.stop().slideToggle();
		})


		//Add "eye" for password field on the "Refund Start" page
		$('.refund-system-front .password-wrapper .dashicons').on('click', function(){
			let $field = $(this).closest('.password-wrapper').find('input');
			if($(this).hasClass('dashicons-visibility')){
				$field.attr('type', 'text');
			} 
			else{
				$field.attr('type', 'password');
			}
			$(this).toggleClass('dashicons-hidden dashicons-visibility');
		})


		//Add custom title attributes to the Refund System pages
// 		$('.refund-select-order-page .refund-disable').tooltip();


		/*
			Select Like element functions (on the Refund Select Item page)
		*/
		
		$('.refund-system-front .select-like-block .title').on('click', function(){
			$(this).closest('.select-like-block').find('ul').stop().slideToggle();
			$(this).find('.dashicons').toggleClass('dashicons-arrow-down dashicons-arrow-up');
		})

		$('.refund-system-front .select-like-block li').on('click', function(){
			let $select = $(this).closest('.rc-fancy-select').find('select');
			$select.val($(this).text());
			$(this).addClass('active').siblings().removeClass('active');
          console.log('123')
          	$(this).closest('[data-item-id]').find('.item_note_div').fadeIn(); 
		});

		/* END Select Like element functions */


		//Select Order Without Account Form
		$('.refund-without-account-block').on('submit', function(e){
			e.preventDefault();
			let $form = $(this);

			let $loader = $('<i>',{class:'fas fa-spinner fa-spin'});
			$form.find('.button').append($loader);

			$.ajax({
				url:'/wp-admin/admin-ajax.php',
				method:"POST",
				data:$form.serialize(),
				dataType:'json',
				success:function(response){
					$form.find('.error').removeClass('active').find('li').css('display','none');
					if(response.result){
						location.href = "/refund-select-order";
					}
					else{
						$form.find('.error').addClass('active').find('.'+response.reason).removeAttr('style');
					}
				},
				error:function(){
					show_message(rs_general_error_message);
				},
				complete:function(){
					$loader.remove();
				}
			});
		})


		let $si_form = $('.refund-select-items-page');

		/* Select Item Page Code */
		$si_form.find('h2').on('click', function(){

			let $element = $(this).next();
			let step = $element.data('step');

			if(step === si_state){
				return false;
			}

			if(si_available_step < step){
				show_message('You need to click on the "Next Step" button on the current step .');
				return false;
			}

			$(this).addClass('active').siblings('h2').removeClass('active');

			$('.step-'+si_state).slideUp();
			$element.slideDown(function(){
				$(this).css('display','flex');
			})

			si_state = step;			
		});

		//Show Refund Type Note
		$si_form.find('.refund-types-list label').on('click', function(){
			let note = $(this).closest('li').data('note');
			let $element = $(this).closest('.product-info').find('.refund-type-note');
			if(note){
				$element.css('display','block');
				$element.html(note);
			}
			else{
				$element.css('display','none');
			}
		})


		//SI - Select Item
		let si_state = 1;
		let si_available_step = 1;

		//Elements cache
		let $si_step1 = $('.step-1');
		let $si_step1_checkbox = $si_step1.find('input[type=checkbox].pick-item');
		let $si_step1_select_items = $si_step1.find('.select-like-block li');

		let $si_step2 = $('.step-2');
		let $si_step2_items = $si_step2.find('li.item');

		let $si_step3 = $('.step-3');
		let $si_step3_items = $si_step3.find('li.item');


		//Change quantity
		$si_step1.find('.quantity-block input').on('change', function(){
			let min = $(this).attr('min');
			let max = $(this).attr('max');
			let value = $(this).val();

			if(value < min){
				$(this).val(min)
				value = min;
			}
			if(value > max){
				$(this).val(max);
				value = max;
			}
			$(this).val(value);

			let item_id = $(this).closest('li').data('item-id');
			$si_step3_items.filter('.item-'+item_id).find('.quantity .value').html(value);
		});


		//Select Refund Reason
		$si_step2_items.find('.refund-types-list input').on('change', function(){
			let value = $(this).closest('label').text();
			let item_id = $(this).closest('.item').data('item-id');
			$si_step3_items.filter('.item-'+item_id).find('.refund-type').html(value);
		})



		//Remove "nothing picked" error label from Checkbox
		//+ Remove "Not Selected" error if checkbox was unchecked
		//+ Remove "Wax Confirm" not checked error
		$si_step1_checkbox.on('click', function(){
			si_available_step = 1;

			$(this).removeClass('error');

			if($(this).hasClass('error-no-item')){
				$si_step1_checkbox.removeClass('error error-no-item');
			}

			if(!$(this).prop('checked')){
				$(this).closest('li').find('.select-like-block').removeClass('error');
			}

			//Remove error from "Wax Confirm Block"
			$(this).closest('li').find('.wax-confirm-block input').removeClass('error');
			$(this).closest('li').find('.wax-confirm-block').removeClass('textError');
		});


		//Select reason function
		$si_step1_select_items.on('click', function(){
			let $select_block = $(this).closest('.select-like-block').removeClass('error'); //Remove "Not Selected" error from Select block
			let $item = $select_block.closest('li')
			let item_id =  $item.data('item-id');
			let reason = $(this).html();

			//If the user change Refund Reason to the "Other" and the Additional Note field is empty the user need to go through Validation Process
			if(reason == "Other" && $item.find('textarea').val().trim().length < 1){
				si_available_step = 1;
			}

			$si_step3_items.filter('.item-'+item_id).find('.return-reason').html(reason);
		});


		//Remove "Not Picked, But Filled Additional Note" error
		$si_step1.find('textarea').on({
			'input': function(){
				if($(this).val().trim().length >=3){
					$(this).removeClass('error');
				}

				if(!$(this).val().trim()){
                  $(this).closest('li').find('input[type=checkbox].error-additional-note-field:not(:checked)').removeClass('error-additional-note-field error');
				}
			},
			'change':function(){
				let value = $(this).val().trim();
				let item_id = $(this).closest('li').data('item-id');
				let $step3_item_refund_info_block = $si_step3_items.filter('.item-'+item_id).find('.return-reason-note');
				if(value){
					$step3_item_refund_info_block.addClass('active');
				}
				else{
					$step3_item_refund_info_block.removeClass('active');

					//If the user remove Additional Note and the Refund Reasion is "Other" the user need go through Validation Process
					if($(this).closest('li').find('select').val() == 'Other'){
						si_available_step = 1;
					}
				}
				$step3_item_refund_info_block.find('.value').html(value);
			}
		});


		//Remove error from "Wax approve checkbox"
		$('.wax-confirm-block input').on('change', function(){
			$(this).removeClass('error');
			$(this).closest('li').find('.wax-confirm-block').removeClass('textError');
			si_available_step = 1;
		})


		//Click "Next" on the First Step (Select a Reason)
		$si_step1.find('.button').on('click', function(event, ignore_select_unchecked_validation){


			/* Remove Previous Validation */
			$si_step1_checkbox.removeClass('error-additional-note-field');

			/* Validation */

			//Get checked items
			let $checked_items = $si_step1_checkbox.filter(':checked')
			
			//No item checked - validation
			if(!$checked_items.length){
				$si_step1_checkbox.addClass('error error-no-item');

				//Scroll to the first problem item
				scroll_to_item($si_step1_checkbox.first());

				show_message("You need to pick at least one item to refund.");
				return false;
			}

			//Reason didn't selected - validation
			let seleted_items_validation = true;
			$checked_items.each(function(){
				let $select = $(this).closest('li').find('.select-like-block');
				if(!$select.find('.active').length){
					$select.addClass('error');
					if(seleted_items_validation){
						//Scroll to the first problem item
						scroll_to_item($select);
						seleted_items_validation = false;
					}
				}
			})
			if(!seleted_items_validation){
				show_message("You need to select a refund reason for selected items.")
				return false;
			}


			//Selected Reason & Unchecked Items - validation
			if(!ignore_select_unchecked_validation){
				let select_reason_unchecked_items_validation = true;
				$si_step1_select_items.filter('.active').each(function(){
					if($(this).closest('.select-like-block').closest('li').find('input[type=checkbox].pick-item:not(:checked)').length){
						select_reason_unchecked_items_validation = false;
					}
				});

				$si_step1.find('textarea').each(function(){
					if($(this).val().trim() && $(this).closest('li').find('input[type=checkbox].pick-item:not(:checked)').length){
						select_reason_unchecked_items_validation = false;
					}
				})

				if(!select_reason_unchecked_items_validation){
					$('.abandon-confirm').popups({effect:"growing"});
					return false;
				}
			}


			//The user selected "Other" reason but didn't fill "Additional Note" field 
			let other_reasond_additional_note = true;
			$si_step1_select_items.filter('.active').each(function(){
				let $block = $(this).closest('.select-like-block').closest('li')
				let $additional_note = $block.find('textarea');
				if(
					!$block.find('input[type=checkbox].pick-item:not(:checked)').length
					&& $(this).html()
					&& $additional_note.val().trim().length < 3
				){
					$additional_note.addClass('error');
					if(other_reasond_additional_note){
						scroll_to_item($additional_note);
						other_reasond_additional_note = false;
					}
				}
			})

			if(!other_reasond_additional_note){
				show_message('Please provide additional details');
				return false;
			}

			//Check Wax Validation
			let wax_confirm_validation = true;
			$checked_items.each(function(){
				let $confirm_checkbox = $(this).closest('li').find('.wax-confirm-block input:not(:checked)');
				let $confirm_text = $(this).closest('li').find('.wax-confirm-block');
				if($confirm_checkbox.length){
					$confirm_checkbox.addClass('error');
					$confirm_text.addClass('textError');
					if(wax_confirm_validation){
						//Scroll to the first problem item
						scroll_to_item($confirm_checkbox);
						wax_confirm_validation = false;
					}
				}
			})
			if(!wax_confirm_validation){
				show_message("Please agree to terms: Open wax containers are NOT eligible for return, exchange, or refund.")
				return false;
			}


			/* END Validation */

			open_next_step($si_step1, $si_step2);

			$si_step2_items.removeClass('active');
			$si_step3_items.removeClass('active');

			$checked_items.each(function(){
				let picked_item_id = $(this).data('item-id');
				$si_step2_items.filter('.item-'+picked_item_id).addClass('active');
				$si_step3_items.filter('.item-'+picked_item_id).addClass('active')
			});


			//Change Active & Available step
			si_state = 2;
			if(si_available_step === 1){
				si_available_step = 2;
			}
		})



		//Remove unpicked return method validation error
		$si_step2_items.find('.refund-types-list input').on('change', function(){
			$(this).closest('.refund-types-list').removeClass('error');
		})

		//Remove error from "Approve condition checkbox"
		let $return_condition_checkbox = $si_step2.find('.refund-conditions input');
		let $return_condition_text = $si_step2.find('.refund-conditions');
		$return_condition_checkbox.on('change', function(){
			$(this).removeClass('error');
			$(this).closest('li').find('.refund-conditions').removeClass('textError');
			si_available_step = 2;
		});

		//Click "Next" on the Second Step (Return types and Conditions)
		$si_step2.find('.button').on('click', function(){

			//Validation - All picked items should have picked refund method
			let refund_method_validation = true; 

			$si_step2_items.filter('.active').find('.refund-types-list').each(function(){
				if(!$(this).find('input:checked').length){
					$(this).addClass('error');

					if(refund_method_validation){
						refund_method_validation = false;
						scroll_to_item($(this));
					}

				}
			});
			if(!refund_method_validation){
				show_message("You need to select a type of return for picked items.");
				return false;
			}

			//Check that user approve return conditions
			if(!$return_condition_checkbox.prop('checked')){
				$return_condition_checkbox.addClass('error');
				$return_condition_text.addClass('textError');
				scroll_to_item($return_condition_checkbox);
				show_message("Check the box and agree to terms below");
				return false;
			}


			open_next_step($si_step2, $si_step3);

			//Change Active & Available step
			si_state = 3;
			si_available_step = 3;
		});


		//Form send available only throught the "Confirm" button
		$si_form.on('submit', function(e){
			e.preventDefault();
		});

		//Send refund request
		$si_step3.find('.confirm').on('click', function(){
			let $loader = $('<i>',{class:'fa fa-spinner fa-spin'});
			$(this).append($loader);
          
          var items = []
          
          var objToday = new Date(),
              weekday = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'),
              dayOfWeek = weekday[objToday.getDay()],
              domEnder = function() { var a = objToday; if (/1/.test(parseInt((a + "").charAt(0)))) return "th"; a = parseInt((a + "").charAt(1)); return 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th" }(),
              dayOfMonth = today + ( objToday.getDate() < 10) ? '0' + objToday.getDate() + domEnder : objToday.getDate() + domEnder,
              months = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'),
              curMonth = months[objToday.getMonth()],
              curYear = objToday.getFullYear(),
              curHour = objToday.getHours() > 12 ? objToday.getHours() - 12 : (objToday.getHours() < 10 ? "0" + objToday.getHours() : objToday.getHours()),
              curMinute = objToday.getMinutes() < 10 ? "0" + objToday.getMinutes() : objToday.getMinutes(),
              curSeconds = objToday.getSeconds() < 10 ? "0" + objToday.getSeconds() : objToday.getSeconds(),
              curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";
          var today = dayOfWeek + " " + dayOfMonth + " of " + curMonth + ", " + curYear+' '+curHour + ":" + curMinute + ":" + curSeconds + " "  + curMeridiem;

          var countItems = 0;
          var countPrice = 0;
          
          $('.pick-item[type="checkbox"]').each(function(){
            var multiplication_fac = ($(this).parent().find('[name="item_quantity"]').val()/parseInt($(this).parent().find('.tot-quan').html().replace('$','').replace(',','')))
            if($(this).prop('checked')){
              console.log( $(this).parent().find('tax_price').val())
              countItems++
              if($(this).parent().find('span.total.important').text()){
              countPrice = countPrice+parseFloat($(this).parent().find('span.total.important').text().trim().replace('$','').replace(',',''))*multiplication_fac
              }
              items.push( {
                "item_id": $(this).parent().find('[name="item_id"]').val(),
                "item_active": $(this).val(),
                "item_quantity": $(this).parent().find('[name="item_quantity"]').val(),
                "item_reason": $(this).parent().find('.reason_ul li.active').text().trim(),
                "item_additional_note": $(this).parent().find('[name="item_additional_note"]').val(), 
                "item_refund-type": $('[data-type-id="'+$(this).parent().find('[name="item_id"]').val()+'"]:checked').val(),
                "image_url": $(this).parent().find('.image-block img').prop('src'),
                "item_name": $(this).parent().find('.product-name-blcok').html().trim(),
                "item_url": $(this).parent().find('.item_url').val(),
                "price": '$'+parseFloat($(this).parent().find('span.total.important').text().trim().replace('$','').replace(',',''))*multiplication_fac,
                "tax_price": '$'+parseFloat($(this).parent().find('.tax_price').val().replace('$','').replace(',',''))*multiplication_fac,
                'refund_createdAt':today
                
              } )
            }
          })

          
          var json = {
            'order-number':$('[name="order-number"]').val(),
            'order-id':$('[name="order-id"]').val(),
            'customer-id':$('.customer_id').val(),
            'customer-name':$('.customer_name').val(),
            'customer-email':$('.customer_email').val(),
            'refund_status':'Created',
            'refund_createdAt':today,
            'items':items,
            'refund_items': countItems,
            'refund_price': '$'+countPrice
          }

			$.ajax({
				url: 'https://misscireapi.com/api/api/star/',
				method: "POST",
				data: JSON.stringify(json),
              
				success: function(data){
                  console.log(data)
					if(data.status == 'exists'){
						show_message(`<div class="title">
			Your return request has<br>been submitted.
		</div><div class="information">You already created a Return Request for this order</div>`);
					}else if(data.status == 'success'){
						$('.send-request').popups({effect:"growing"});
                    }else{
                    	show_message(`<div class="title">
			Your return request has<br>been submitted.
		</div><div class="information">`+data.status+'.<br>We will contact you soon via email with further instructions.</div>');
                    }
					if(!data){
						show_message(rs_general_error_message);
					}
				},
				error: function(e){
                  console.log('In error')
                  console.log(e)
					show_message(rs_general_error_message);
				},
				complete: function(){
					$loader.remove();
				}
			})
			
		})




		$('.abandon-confirm .back').on('click', function(){
			let first_item_encounter = false;
			$si_step1_select_items.filter('.active').each(function(){
				let $element_for_check = $(this).closest('.select-like-block').closest('li').find('input[type=checkbox].pick-item:not(:checked)');
				if($element_for_check.length && !first_item_encounter){
					first_item_encounter = true;
					scroll_to_item($element_for_check);
				}
				$element_for_check.addClass('error');
			});

			//Show unchecked checkbox with filled Additional Note field
			$si_step1.find('textarea').each(function(){
				let $element_for_check = $(this).closest('li').find('input[type=checkbox].pick-item:not(:checked)');
				if($(this).val().trim() && $element_for_check.length){
					if(!first_item_encounter){
						first_item_encounter = true;
						scroll_to_item($element_for_check);						
					}
					$element_for_check.addClass('error error-additional-note-field');
				}
			});

		});


		$('.abandon-confirm .continue').on('click', function(){
			$si_step1.find('.button').trigger('click', [true]);
		});


		/* END Select Item Page Code */


		function open_next_step($step_prev, $step_next){
			$step_prev.slideUp().prev('h2').removeClass('active');
			$step_next.slideDown(function(){
				$(this).css('display','flex');
			}).prev('h2').addClass('active');
		}



		function scroll_to_item($element){
			let position = $element.offset().top - $element.height()/2;
			let window_size = $(window).height();
			let needed_position = position - window_size/2;
			$('html,body').animate({scrollTop:needed_position},300);
		}


		function show_message(text){
			let $popup_message = $('.rs-popup.message');
			$popup_message.find('.text').html(text);
			$popup_message.popups({effect:"growing"});
		}




	})
    
    setTimeout(()=>{
               $.ajax({
               url: "https://misscireapi.com/api/getAllData/?email="+$('#my_cust_email').val(),
      type: 'GET',
        dataType: 'json', // added data type
          success: function(res) {
            console.log(res);
            document.querySelectorAll('[data-ord_id]').forEach(x => {
              if(res.refund_created.indexOf(x.getAttribute('data-ord_id')) > -1){
                x.classList.add('disabled')
                x.innerText = 'Return requested'
              }
              $('.refund-system-front').fadeIn();
            })
          }
});
},100)

    

})(jQuery);

    
    function rediR(){
      if($('[data-step="3"]').css('display') == 'flex'){
        window.location.href = '/'
      }
    }
